import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import ProductCard from '../components/ProductCard';
import { getCmsCollection, getCmsPage } from '../lib/cms';

export default function DiversePage() {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function loadDiverse() {
      try {
        const [res, pageData] = await Promise.all([
          getCmsCollection('produkter', {
            kategori: 'diverse',
            limit: 20,
            sort: 'sorteringsorden',
            order: 'asc',
          }),
          getCmsPage('/diverse'),
        ]);

        if (isMounted) {
          if (pageData) setPage(pageData);
          setProducts(res.items || []);
          setLoading(false);
        }
      } catch (err) {
        console.error('Fejl ved indlæsning af diverse produkter:', err);
        if (isMounted) setLoading(false);
      }
    }

    loadDiverse();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <SeoHead
        title={page?.meta_title || "Diverse & Fodertilbehør - KROMIX A/S"}
        description={page?.meta_description || "Vi kan tilbyde forskellige fodertilbehør: Lakseolie, hvalpemælk, Josera Knuspies, Loopies godbidder, kattegrus og fuglefrø."}
      />

      {/* Hero Header */}
      <section className="bg-[#39463A] text-white py-14 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-bold uppercase tracking-widest text-[#DED3C0] mb-2 block">
              {page?.badge_tekst || 'Tilbehør & Specialprodukter'}
            </span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              {page?.overskrift || 'Fodertilbehør & Diverse'}
            </h1>
            <p className="text-base sm:text-lg text-[#FCFAF5]/90 mt-3 leading-relaxed">
              {page?.undertekst || 'Vi skaffer resultater. Rigtig ernæring - sund levevis. Vi kan tilbyde forskellige fodertilbehør, tilskud, sunde godbidder, kattegrus og fuglefrø af høj kvalitet.'}
            </p>
          </div>
        </div>
      </section>

      {/* Catalog Grid */}
      <section className="py-12 bg-[#F4EFE5] min-h-[500px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="py-20 text-center text-sm text-[#39463A]/80">
              <i className="fa-solid fa-spinner fa-spin text-2xl text-[#71806A] mb-2 block" />
              Indlæser tilbehør & diverse produkter...
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}

          {/* Guidance note */}
          <div className="mt-14 p-6 rounded-2xl bg-[#DED3C0]/40 border border-[#DED3C0] flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div className="space-y-1 max-w-2xl">
              <h3 className="text-base font-bold text-[#39463A]">
                Spørgsmål til foderblandinger og tilbehør?
              </h3>
              <p className="text-xs text-[#39463A]/80">
                Kontakt KROMIX på telefon 75 73 18 61 eller via kontaktformularen for personlig rådgivning og produktinformation.
              </p>
            </div>
            <Link
              to="/kontakt"
              className="px-6 py-3 rounded-xl bg-[#71806A] hover:bg-[#5C6A56] text-white text-xs font-bold uppercase tracking-wider transition-all shadow-md shrink-0 whitespace-nowrap"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
